/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import "./index.css";
import { Link, useParams } from "react-router-dom";
import GlueLogo from "../../glueLogo";
import ContactModal from "../../ContactSales";
import { FaTrash } from "react-icons/fa";

const defaultFaqData = [
    {
        question: "What is GlueID?",
        answer:
            "GlueID is an interactive graph visualization tool that helps uncover hidden patterns in your data.",
    },
];

export default function FAQ({
    headerFalse = false,
    enable_faq_editing = false,
    faqData = [],
    onChange
}) {

    const { username } = useParams();

    const [openIndex, setOpenIndex] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);

    // =========================================
    // ✅ LOCAL FAQ STATE
    // =========================================
    const [localFaqs, setLocalFaqs] = useState(
        defaultFaqData
    );

    // =========================================
    // ✅ FETCH FAQS
    // =========================================
    useEffect(() => {

        // =====================================
        // ✅ ADMIN / CONTROLLED MODE
        // =====================================
        if (onChange) {

            setLocalFaqs(
                faqData?.length
                    ? faqData
                    : defaultFaqData
            );

            return;
        }

        // =====================================
        // ✅ STANDALONE FETCH MODE
        // =====================================
        const fetchFaqs = async () => {

            try {

                const res = await fetch(
                    "https://5549ucvkb3.execute-api.us-east-2.amazonaws.com"
                );

                const data = await res.json();

                const body =
                    typeof data.body === "string"
                        ? JSON.parse(data.body)
                        : data;

                console.log(
                    "FAQ RESPONSE:",
                    body
                );

                if (
                    Array.isArray(body?.faq)
                    && body.faq.length > 0
                ) {

                    setLocalFaqs(body.faq);

                } else {

                    setLocalFaqs(defaultFaqData);
                }

            } catch (err) {

                console.error(
                    "FAQ fetch failed:",
                    err
                );

                setLocalFaqs(defaultFaqData);
            }
        };

        fetchFaqs();

    }, [faqData, onChange]);

    // =========================================
    // ✅ UPDATE FAQS
    // =========================================
    const updateFaqs = (updated) => {

        setLocalFaqs(updated);

        if (onChange) {

            onChange(updated);
        }
    };

    // =========================================
    // ✅ TOGGLE FAQ
    // =========================================
    const handleToggle = (index) => {

        setOpenIndex(
            openIndex === index
                ? null
                : index
        );
    };

    // =========================================
    // ✅ UPDATE FAQ FIELD
    // =========================================
    const handleChange = (
        index,
        field,
        value
    ) => {

        const updatedFaq = [...localFaqs];

        updatedFaq[index] = {
            ...updatedFaq[index],
            [field]: value
        };

        updateFaqs(updatedFaq);
    };

    // =========================================
    // ✅ ADD FAQ
    // =========================================
    const addNewFaq = () => {

        updateFaqs([
            ...localFaqs,
            {
                question: "New Question",
                answer: "New Answer",
            },
        ]);
    };

    // =========================================
    // ✅ DELETE FAQ
    // =========================================
    const deleteFaq = (index) => {

        const updatedFaq =
            localFaqs.filter(
                (_, i) => i !== index
            );

        updateFaqs(updatedFaq);
    };

    return (
        <div className="faq-page">

            {/* ================================= */}
            {/* HEADER */}
            {/* ================================= */}

            {headerFalse ? null : (

                <header className="navbar">

                    <Link
                        to="/"
                        style={{
                            textDecoration: "none"
                        }}
                    >

                        <div className="navbar-links">

                            <div className="logo">
                                <GlueLogo />
                            </div>

                            {!username ? (

                                <nav className="nav-links">

                                    <a href="#demo">
                                        Demo
                                    </a>

                                    <a href="#team">
                                        Team
                                    </a>

                                    <Link
                                        to="/help"
                                        style={{
                                            textDecoration:
                                                "none"
                                        }}
                                    >
                                        <a className="login">
                                            Help
                                        </a>
                                    </Link>

                                    <Link
                                        to="/sales"
                                        style={{
                                            textDecoration:
                                                "none"
                                        }}
                                    >
                                        <a className="login">
                                            Pricing
                                        </a>
                                    </Link>

                                </nav>

                            ) : (

                                <div className="nav-links">

                                    <Link
                                        to="/glue-dashboard"
                                        style={{
                                            textDecoration:
                                                "none"
                                        }}
                                    >
                                        <a>
                                            Go to Dashboard
                                        </a>
                                    </Link>

                                </div>
                            )}
                        </div>
                    </Link>

                    {!username && (

                        <div className="actions">

                            <a
                                className="btn-primary-link"
                                href="https://datahub.glueid.com"
                            >
                                Login
                            </a>
                            <ContactModal triggerClass="btn-outline" />
                            <a
                                className="btn-primary-link"
                                href="https://datahub.glueid.com/signup"
                            >
                                Sign Up
                            </a>
                        </div>
                    )}

                </header>
            )}

            {/* ================================= */}
            {/* FAQ SECTION */}
            {/* ================================= */}

            <section className="faq-container">

                <div className="faq-header-row">

                    <h1 className="faq-title">
                        Frequently Asked Questions
                    </h1>

                    {enable_faq_editing && (

                        <button
                            type="button"
                            className="add-faq-btn"
                            onClick={addNewFaq}
                        >
                            + Add FAQ
                        </button>
                    )}

                </div>

                {localFaqs.map((faq, index) => {

                    const isOpen =
                        openIndex === index;

                    const isEditing =
                        editingIndex === index;

                    return (

                        <div
                            key={index}
                            className={`faq-item ${isOpen
                                    ? "open"
                                    : ""
                                }`}
                        >

                            {/* QUESTION */}
                            <div
                                className="faq-question"
                                onClick={() =>
                                    handleToggle(index)
                                }
                            >

                                {enable_faq_editing &&
                                    isEditing ? (

                                    <input
                                        className="faq-edit-input"
                                        value={
                                            faq.question
                                        }
                                        onChange={(e) =>
                                            handleChange(
                                                index,
                                                "question",
                                                e.target.value
                                            )
                                        }
                                    />

                                ) : (

                                    <span>
                                        {faq.question}
                                    </span>

                                )}

                                {/* ACTIONS */}
                                <div className="faq-actions">

                                    {enable_faq_editing && (

                                        <>
                                            <button
                                                type="button"
                                                className="faq-edit-btn"
                                                onClick={(e) => {

                                                    e.stopPropagation();

                                                    setEditingIndex(
                                                        isEditing
                                                            ? null
                                                            : index
                                                    );
                                                }}
                                            >
                                                {isEditing
                                                    ? "Save"
                                                    : "Edit"}
                                            </button>

                                            <button
                                                type="button"
                                                className="faq-delete-btn"
                                                onClick={(e) => {

                                                    e.stopPropagation();

                                                    deleteFaq(index);
                                                }}
                                            >
                                                <FaTrash />
                                            </button>
                                        </>
                                    )}

                                    <span className="faq-toggle">
                                        {isOpen
                                            ? "-"
                                            : "+"}
                                    </span>

                                </div>
                            </div>

                            {/* ANSWER */}
                            {isOpen && (

                                <div className="faq-answer">

                                    {enable_faq_editing &&
                                        isEditing ? (

                                        <textarea
                                            className="faq-edit-textarea"
                                            value={
                                                faq.answer
                                            }
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "answer",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    ) : (

                                        faq.answer

                                    )}

                                </div>
                            )}

                        </div>
                    );
                })}

            </section>
        </div>
    );
}